import { render, staticRenderFns } from "./ShowDetailRequest.vue?vue&type=template&id=ff2f72ba&scoped=true&"
import script from "./ShowDetailRequest.vue?vue&type=script&lang=js&"
export * from "./ShowDetailRequest.vue?vue&type=script&lang=js&"
import style0 from "./ShowDetailRequest.vue?vue&type=style&index=0&id=ff2f72ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f72ba",
  null
  
)

export default component.exports